const Agridential = {
    //network info
    averageBlockTime: 135,
    chainId: '0x22b8', //8888
    name: 'Agridential',
    shortName: 'agd',
    token: 'AGD',
    type: 'Ethereum 1.0',
    timeInterval: 100_000,

    //endpoint
    endpoint: process.env.AGRIDENTIAL_ENDPOINT || 'https://agridential.vbchain.vn/VBC001',
    chainApiEndpoint: process.env.AGRIDENTIAL_API_ENDPOINT,
    // infoApiEndpoint: process.env.AGRIDENTIAL_INFO_ENDPOINT,

    //style
    chartStyle: ['#cd180c', '#fb4231'],
    color: {
        from: '#cd180c',
        to: '#fb4231',
        fromPosition: '45.78%',
        toPosition: '88.78%'
    },

    //image
    backgroundImage: 'https://res.cloudinary.com/vbchain/image/upload/v1627889455/block_explorer/agdHome_whul2v.svg',

    networkIcon:
        'https://res.cloudinary.com/agridential/image/upload/v1600757777/Logo/agdnew_ctihrd-removebg-preview_km4ppl.png',
    averageBlockTimeIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1627890417/block_explorer/GeneralInfo/Agridential/agdBlockTime_thhe55.svg',
    totalTransactionsIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1627890476/block_explorer/GeneralInfo/Agridential/agdTransaction_iqr6m8.svg',
    totalActiveAddressesIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1627890517/block_explorer/GeneralInfo/Agridential/agdAccount_ynlgax.svg',
    latestBlockIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1627890519/block_explorer/GeneralInfo/Agridential/agdBlock_v9mxtn.svg'
}

module.exports = Agridential
